import { Card, Modal, } from 'react-bootstrap';
const { Header, Body, Footer } = Card;

export default function DefaultModal() {
    return (
        <Modal.Body>
            <Card>
                <Header>Modal Header!!</Header>
                <Body>Modal Body</Body>
                <Footer>Modal Footer</Footer>
            </Card>
        </Modal.Body>
    )
}